module.exports = __webpack_public_path__ + "static/media/more-options-highlighted-dark.7cec41e8.svg";